import { Component, Input } from '@angular/core';
import SlotFirstPageModel from '../../models/slot-first-page.model';

@Component({
  selector: '[new-offer-tv-section]',
  templateUrl: './new-offer-tv-section.component.html',
})
export class NewOfferTvSectionComponent {

  @Input() public slot: SlotFirstPageModel;

  constructor() {

  }
}
